import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const LoggedInQuery = gql`
  query {
    loggedIn {
      logged
      user {
        id
        email
        language
        privileges
        countries {
          id
          name
        }
      }
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetUserQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { loggedIn, user }: any = this.props;
    return this.props.children({ loggedIn, user });
  }
}

export default compose(
  graphql<IInputProps, Response>(LoggedInQuery, {
    name: 'loggedIn',
    options: props => ({
      fetchPolicy: 'network-only'
    })
  }),
)(GetUserQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Users/User.tsx